const stripePublishableKeyPattern = /^pk_(test|live)_[A-Za-z0-9_]+$/;

function normalizeStripePublishableKey(
  value: string | null | undefined,
): string | null {
  const trimmed = value?.trim() ?? "";

  return stripePublishableKeyPattern.test(trimmed) ? trimmed : null;
}

export { normalizeStripePublishableKey };
